import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash-es';

import IconClock from '../../../assets/images/icon-clock.svg';
import IconFlag from '../../../assets/images/icon-flag.svg';
import IconWorldBolt from '../../../assets/images/icon-world-bolt.svg';
import UserBoltIcon from '../../../assets/images/UserBoltIcon.svg';
import LabelWithIcon from '../../../components/shared/Label/LabelWithIcon';
import {
  EXPERIENCE_LEVEL_KEYS,
  OPPORTUNITY_TYPE_KEYS,
  REMOTE_WORK_TYPE_KEYS,
  WORK_PLACE_TYPE_KEYS,
} from '../../../constants/commonConstants.js';

import styles from './JobInfoSection.module.scss';

const JobInfoSection = ({ work_place_type, work_type, job_experience_name, job_urgency_type_name, customStyles }) => {
  const { t } = useTranslation('common');

  const getWorkPlaceTypeLabel = (name) =>
    WORK_PLACE_TYPE_KEYS[name] ? t(`workPlaceType.${WORK_PLACE_TYPE_KEYS[name]}`) : name;
  const getOpportunityTypeLabel = (name) =>
    OPPORTUNITY_TYPE_KEYS[name] ? t(`opportunityType.${OPPORTUNITY_TYPE_KEYS[name]}`) : name;
  const getExperienceLevelLabel = (name) =>
    EXPERIENCE_LEVEL_KEYS[name] ? t(`experienceLevel.${EXPERIENCE_LEVEL_KEYS[name]}`) : name;
  const getRemoteWorkLabel = (name) =>
    REMOTE_WORK_TYPE_KEYS[name] ? t(`remoteWork.${REMOTE_WORK_TYPE_KEYS[name]}`) : name;

  return (
    <div className={`${styles.jobInfoContainer} ${customStyles}`}>
      {!isEmpty(work_place_type) && (
        <LabelWithIcon varient="label-primary" img={IconWorldBolt} tag={getWorkPlaceTypeLabel(work_place_type)} />
      )}
      {!isEmpty(work_type) && (
        <LabelWithIcon varient="label-primary" img={IconClock} tag={getOpportunityTypeLabel(work_type)} />
      )}
      {!isEmpty(job_experience_name) && (
        <LabelWithIcon varient="label-primary" img={UserBoltIcon} tag={getExperienceLevelLabel(job_experience_name)} />
      )}
      {job_urgency_type_name === 'Urgent' && (
        <LabelWithIcon varient="label-warning" img={IconFlag} tag={getRemoteWorkLabel(job_urgency_type_name)} />
      )}
    </div>
  );
};

export default JobInfoSection;
